import React, { Fragment } from 'react';
export function Footer() {
  return <footer className="w-full bg-orla-sienna pb-12 pt-24" data-id="element-117">
      <div className="mx-auto max-w-[1240px] px-6 md:px-8" data-id="element-118">
        {/* Top block — big final CTA */}
        <div className="grid grid-cols-1 items-center gap-8 md:grid-cols-12 md:gap-16" data-id="element-119">
          <div className="flex flex-col items-start md:col-span-8" data-id="element-120">
            <h2 className="max-w-[560px] font-display text-[28px] font-black leading-[1.1] tracking-[-0.02em] text-orla-bone md:text-[40px]" data-id="element-121">
              Expert perimenopause care, delivered to your door.
            </h2>

            <div className="mt-6 inline-flex items-center rounded-full bg-orla-saffron px-3.5 py-1.5 font-body text-[12px] font-semibold text-orla-sienna" data-id="element-122">
              ✓ HSA/FSA eligible
            </div>

            <div className="mt-8 flex flex-col items-center gap-5 sm:flex-row" data-id="element-123">
              <button className="rounded-full bg-orla-bone px-8 py-3.5 font-body text-[15px] font-semibold text-orla-sienna transition-colors hover:bg-orla-bone/90" data-id="element-124">
                Start My Care
              </button>
              <a href="#" className="font-body text-[14px] font-semibold text-orla-saffron hover:underline" data-id="element-125">
                Returning patient? Log in →
              </a>
            </div>
          </div>

          <div className="flex justify-center md:col-span-4" data-id="element-126">
            <div className="relative flex h-[240px] w-[240px] rotate-3 items-center justify-center rounded-full bg-[#F8F3EA] shadow-lg" data-id="element-127">
              <svg width="120" height="160" viewBox="0 0 120 160" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-128">
                {/* Dropper Cap */}
                <path d="M45 20C45 14.4772 49.4772 10 55 10H65C70.5228 10 75 14.4772 75 20V40H45V20Z" fill="#1F1B17" data-id="element-129" />
                <rect x="40" y="40" width="40" height="15" rx="2" fill="#1F1B17" data-id="element-130" />
                {/* Bottle Body */}
                <path d="M35 65C35 59.4772 39.4772 55 45 55H75C80.5228 55 85 59.4772 85 65V140C85 145.523 80.5228 150 75 150H45C39.4772 150 35 145.523 35 140V65Z" fill="#9B4722" data-id="element-131" />
                {/* Label */}
                <rect x="35" y="80" width="50" height="45" fill="#F2E9DB" data-id="element-132" />
                <rect x="45" y="90" width="30" height="4" rx="2" fill="#1F1B17" data-id="element-133" />
                <rect x="45" y="100" width="20" height="3" rx="1.5" fill="#6B5E52" data-id="element-134" />
                <rect x="45" y="108" width="25" height="3" rx="1.5" fill="#6B5E52" data-id="element-135" />
                {/* Dropper Glass Tube (visible inside) */}
                <rect x="57" y="55" width="6" height="20" fill="#E5DCC9" fillOpacity="0.5" data-id="element-136" />
              </svg>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-16 h-px w-full bg-orla-bone/20" data-id="element-137"></div>

        {/* 5-column link grid */}
        <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-5 md:gap-8" data-id="element-138">
          <div className="flex flex-col" data-id="element-139">
            <h3 className="mb-5 font-body text-[14px] font-semibold uppercase tracking-[0.06em] text-orla-saffron" data-id="element-140">
              GET STARTED
            </h3>
            <ul className="flex flex-col gap-3" data-id="element-141">
              {['Start My Care', 'Check My Symptoms', 'Shop Treatments', 'Bioidentical HRT', 'HSA/FSA Eligibility'].map(link => <li key={link} data-id="element-142">
                  <a href="#" className="font-body text-[14px] text-orla-bone/80 hover:text-orla-bone hover:underline" data-id="element-143">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col" data-id="element-144">
            <h3 className="mb-5 font-body text-[14px] font-semibold uppercase tracking-[0.06em] text-orla-saffron" data-id="element-145">
              SYMPTOMS
            </h3>
            <ul className="flex flex-col gap-3" data-id="element-146">
              {['Hot Flashes', 'Night Sweats', 'Brain Fog', 'Mood Changes', 'Sleep Problems', 'Weight Gain', 'Fatigue', 'Hair Loss', 'All Symptoms A–Z'].map(link => <li key={link} data-id="element-147">
                  <a href="#" className="font-body text-[14px] text-orla-bone/80 hover:text-orla-bone hover:underline" data-id="element-148">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col" data-id="element-149">
            <h3 className="mb-5 font-body text-[14px] font-semibold uppercase tracking-[0.06em] text-orla-saffron" data-id="element-150">
              LEARN
            </h3>
            <ul className="flex flex-col gap-3" data-id="element-151">
              {['Perimenopause', 'Menopause', 'Hormone Replacement', 'The Prime Letter', 'Treatment Options', 'All Resources'].map(link => <li key={link} data-id="element-152">
                  <a href="#" className="font-body text-[14px] text-orla-bone/80 hover:text-orla-bone hover:underline" data-id="element-153">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col" data-id="element-154">
            <h3 className="mb-5 font-body text-[14px] font-semibold uppercase tracking-[0.06em] text-orla-saffron" data-id="element-155">
              SUPPORT
            </h3>
            <ul className="flex flex-col gap-3" data-id="element-156">
              {['FAQ', 'Help Center', 'Contact Us'].map(link => <li key={link} data-id="element-157">
                  <a href="#" className="font-body text-[14px] text-orla-bone/80 hover:text-orla-bone hover:underline" data-id="element-158">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col" data-id="element-159">
            <h3 className="mb-5 font-body text-[14px] font-semibold uppercase tracking-[0.06em] text-orla-saffron" data-id="element-160">
              COMPANY
            </h3>
            <ul className="flex flex-col gap-3" data-id="element-161">
              {['About Us', 'Our Approach', 'Physicians', 'Pharmacy', 'Reviews', 'Careers', 'Affiliate Program'].map(link => <li key={link} data-id="element-162">
                  <a href="#" className="font-body text-[14px] text-orla-bone/80 hover:text-orla-bone hover:underline" data-id="element-163">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-16 h-px w-full bg-orla-bone/20" data-id="element-164"></div>

        {/* Bottom row */}
        <div className="mt-8 flex flex-col items-center justify-between gap-6 md:flex-row md:gap-0" data-id="element-165">
          <span className="font-display text-[28px] font-black lowercase tracking-tight text-orla-bone" data-id="element-166">
            orla
          </span>

          <div className="flex items-center gap-4" data-id="element-167">
            <SocialIcon type="instagram" data-id="element-168" />
            <SocialIcon type="tiktok" data-id="element-169" />
            <SocialIcon type="youtube" data-id="element-170" />
            <SocialIcon type="facebook" data-id="element-171" />
            <SocialIcon type="linkedin" data-id="element-172" />
            <SocialIcon type="reddit" data-id="element-173" />
            <SocialIcon type="pinterest" data-id="element-174" />
          </div>

          <span className="font-body text-[13px] text-orla-bone/60" data-id="element-175">
            © 2026 Orla. All rights reserved.
          </span>
        </div>

        {/* Fine-print row */}
        <div className="mt-6 flex flex-wrap justify-center gap-4 md:justify-start" data-id="element-176">
          {['Privacy Policy', 'Terms', 'Consumer Health Privacy', 'Telehealth Consent', 'hello@orlahealth.com'].map((link, idx, arr) => <Fragment key={link} data-id="element-177">
              <a href="#" className="font-body text-[12px] text-orla-bone/50 hover:text-orla-bone/80 hover:underline" data-id="element-178">
                {link}
              </a>
              {idx < arr.length - 1 && <span className="text-orla-bone/50" data-id="element-179">·</span>}
            </Fragment>)}
        </div>
      </div>
    </footer>;
}
function SocialIcon({
  type
}: {
  type: string;
}) {
  const getIcon = () => {
    switch (type) {
      case 'instagram':
        return <path d="M16 4H8a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M16.5 7.5v.01" data-id="element-180" />;
      case 'tiktok':
        return <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5v3a3 3 0 0 1-3-3v8a4 4 0 0 1-4-4z" data-id="element-181" />;
      case 'youtube':
        return <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z M9.75 15.02l5.75-3.27-5.75-3.27v6.54z" data-id="element-182" />;
      case 'facebook':
        return <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" data-id="element-183" />;
      case 'linkedin':
        return <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z M2 9h4v12H2z M4 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" data-id="element-184" />;
      case 'reddit':
        return <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1.89-6.398c-.14-.14-.366-.14-.506 0-.677.677-1.638.677-2.315 0-.14-.14-.366-.14-.506 0-.14.14-.14.366 0 .506.816.816 1.93.816 2.747 0 .14-.14.14-.366 0-.506zm3.78 0c-.14-.14-.366-.14-.506 0-.677.677-1.638.677-2.315 0-.14-.14-.366-.14-.506 0-.14.14-.14.366 0 .506.816.816 1.93.816 2.747 0 .14-.14.14-.366 0-.506zM12 4.5c-1.38 0-2.5 1.12-2.5 2.5 0 .37.08.72.22 1.03-1.6.43-2.94 1.3-3.8 2.47H5.5c-1.1 0-2 .9-2 2 0 .8.48 1.5 1.18 1.83-.06.22-.1.45-.1.69 0 2.48 3.36 4.5 7.5 4.5s7.5-2.02 7.5-4.5c0-.24-.04-.47-.1-.69.7-.33 1.18-1.03 1.18-1.83 0-1.1-.9-2-2-2h-.42c-.86-1.17-2.2-2.04-3.8-2.47.14-.31.22-.66.22-1.03 0-1.38-1.12-2.5-2.5-2.5z" data-id="element-185" />;
      case 'pinterest':
        return <path d="M12 2C6.48 2 2 6.48 2 12c0 4.24 2.63 7.85 6.35 9.31-.09-.79-.17-2.01.04-2.87.18-.78 1.17-4.97 1.17-4.97s-.3-.6-.3-1.49c0-1.39.81-2.43 1.81-2.43.85 0 1.26.64 1.26 1.4 0 .85-.54 2.13-.82 3.31-.24.99.5 1.8 1.47 1.8 1.77 0 3.13-1.87 3.13-4.58 0-2.4-1.73-4.08-4.19-4.08-2.85 0-4.52 2.14-4.52 4.34 0 .86.33 1.78.75 2.28.08.1.09.19.07.29-.07.28-.22.9-.25 1.02-.04.13-.14.16-.28.1-1.05-.49-1.7-2.03-1.7-3.27 0-2.66 1.93-5.11 5.58-5.11 2.94 0 5.23 2.1 5.23 4.9 0 2.92-1.84 5.27-4.4 5.27-.86 0-1.67-.45-1.95-.98l-.53 2.03c-.19.74-.71 1.66-1.06 2.22A9.95 9.95 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z" data-id="element-186" />;
      default:
        return null;
    }
  };
  return <a href="#" className="text-orla-bone/70 transition-colors hover:text-orla-bone" data-id="element-187">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" data-id="element-188">
        {getIcon()}
      </svg>
    </a>;
}